import { LeadEmailFormContactStore } from 'common/module/lead/email/form/contact/store';
import { LeadEmailFormContactServiceInterface } from 'common/service/lead-email-form-contact/service.interface';

const service = new LeadEmailFormContactStore();
service.initialize();

export function LeadEmailFormContactService(): LeadEmailFormContactServiceInterface {
  return service;
}
